import styled, { css } from 'styled-components';
import { SvgHelperWrapper } from 'src/components';

export const Play = styled(SvgHelperWrapper)(
  () => css`
    width: 100%;
    height: 100%;
  `,
);

export const PlayButton = styled.button.attrs({
  role: 'button',
})(
  ({ theme }) => css`
    width: ${theme.sz.s8};
    height: ${theme.sz.s8};
    display: flex;
    margin: 0;
    padding: 0;
    background: none;
    border: none;
    cursor: pointer;
  `,
);
